/** Angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
@Injectable({
  providedIn: 'root',
})
export class BydGroupsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService.
   */
  path: string;

  /**
   * Get non standard admin groups.
   *
   * @param projectId the project id
   * @returns Observable<DefectInfo>
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getNonStandardAdminGroups(projectId: number): Observable<any> {
    this.path = `/projects/${projectId}/non-standard-groups`;
    return this.get();
  }

  /**
   * Get link users groups.
   *
   * @param projectId the project id
   * @returns Observable<DefectInfo>
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLinkUsersGroups(projectId: number): Observable<any> {
    this.path = `/projects/${projectId}/users/groups`;
    return this.get();
  }

  /**
   * Implement inherited abstract member 'createNewInstance' from BydRhsAbstractService.
   */
  public createNewInstance() {}
}
